module.exports = __webpack_public_path__ + "img/Kinesis-Stream-Shards-Console.4cff4098.png";